const now = new Date();
const Y = now.getFullYear();
let M = now.getMonth() + 1;
let D = now.getDate();
M = M >= 1 && M <= 9 ? "0" + M : M;
D = D >= 1 && D <= 9 ? "0" + D : D;
const CurrentDate = Y + "" + M + "" + D;
export default CurrentDate;
